'use strict';

const jQuery = require('jquery');

const FormBuilder = require('./../builder');

let ElementClass = require('./../elementClass');

FormBuilder.register('textarea', function(config) {
    let self = {};

    self = new ElementClass(config);

    self.render = function(wrap) {
        let $element = jQuery('<textarea/>');
        let $label;

        $element.attr('name', self.name);
        $element.attr('disabled', self.disabled);
        $element.attr('cols', config.cols || 20);
        $element.attr('rows', config.rows || 2);

        if (false === config.resize) {
            $element.css('resize:none;');
        }

        if (undefined !== self.placeholder) {
            $element.attr('placeholder', self.placeholder);
        }

        if (self.label) {
            $label = jQuery('<label/>');

            if (self.labelClass) {
                $label.addClass(self.labelClass);
            }

            $label.text(self.label);
            wrap.append($label);
        }

        if (false === config.resize) {
            $element.css('resize', 'none');
        }

        if (self.value !== undefined && self.value !== null) {
            $element.val(self.value);
        }

        if (self.elementClass) {
            $element.addClass(self.elementClass);
        }

        return $element;
    };

    self.getData = function() {
        return self.$.find('textarea:first').val();
    };

    return self;
});
